import { useRouter as usePagesRouter } from 'next/compat/router';
import { useEffect } from 'react';

import { useTrack, UseTrackProps } from './useTrack';

export function useTrackPageChange(props: UseTrackProps) {
  const pagesRouter = usePagesRouter();
  const { track } = useTrack(props);

  const handleTrackPageView = () => {
    track({
      slug: 'pageView',
    });
  };

  useEffect(() => {
    // Track once on first entry
    handleTrackPageView();

    if (pagesRouter != null) {
      pagesRouter.events.on('routeChangeComplete', handleTrackPageView);
      return () => pagesRouter.events.off('routeChangeComplete', handleTrackPageView);
    }
  }, []);
}
